import Recipients from './Recipients.jsx';

export default Recipients;
